
import { TargetModel } from '@/libs/Api';
import { CrudAction } from '@/libs/core/+state/models/crud-action';
import { CrudDataStats } from '@/libs/core/+state/models/crud-data-stats';
import { CrudGetter } from '@/libs/core/+state/models/crud-getter';
import { createCrudQueryPayload } from '@/libs/core/+state/models/crud-query-payload';
import { CrudQueryPredicate } from '@/libs/core/+state/models/crud-query-predicate';
import Page from '@/Page.vue';
import { Component, Prop, Ref, Watch } from 'vue-property-decorator';
import { targetsStore } from '@/libs/targets/+state/store';
import TargetDialog from '../components/TargetDialog.vue';
import { Guid } from '@/libs/common/functions/guid';
import moment from 'moment';

@Component({
    components: { TargetDialog },
})
export default class Targets extends Page {
    get headers() {
        return [
            { text: this.$i18n.t('targets.fromDate'), value: 'fromDate', align: 'left', sortable: false },
            { text: this.$i18n.t('targets.toDate'), value: 'toDate', align: 'left', sortable: false },
            { text: this.$i18n.t('targets.scopeHeader'), value: 'scope', align: 'left', sortable: false },
            { text: this.$i18n.t('targets.worldClassOee'), value: 'worldClassOee', align: 'left', sortable: false },
            { text: this.$i18n.t('targets.targetOee'), value: 'targetOee', align: 'left', sortable: false },
            { text: this.$i18n.t('targets.targetOeeAvailability'), value: 'targetOeeAvailability', align: 'left', sortable: false },
            { text: this.$i18n.t('targets.targetOeePerformance'), value: 'targetOeePerformance', align: 'left', sortable: false },
            { text: this.$i18n.t('targets.targetOeeQuality'), value: 'targetOeeQuality', align: 'left', sortable: false },
            { text: '', value: 'id', align: 'left', sortable: false },
        ];
    }

    itemsPerPage = 10;

    @Prop() tenantId!: string;
    @Ref() dialog!: TargetDialog | null;

    @Watch('itemsPerPage')
    itemsPerPageChanged(v: number) {
        window.localStorage.amsItemsPerPage = v && !isNaN(v) ? v.toString() : '10';
    }

    get loading(): boolean {
        return targetsStore.useGetter(CrudGetter.Pending);
    }

    get targets(): any[] {
        // TargetModel with optional navigation props populated by backend
        const data = targetsStore.useGetter(CrudGetter.Data) as any[] | undefined;
        return data ? [...data] : [];
    }

    get totalRows(): number {
        const stats = targetsStore.useGetter(CrudGetter.DataStats) as CrudDataStats | undefined;
        return stats?.rowCount ?? 0;
    }

    mounted() {
        const stored = window.localStorage.amsItemsPerPage;
        this.itemsPerPage = stored && !isNaN(Number(stored)) ? Number(stored) : 10;
        this.load();
    }

    load() {
        targetsStore.dispatch(CrudAction.GetAll, this.getPayload());
    }

    getFilters(): CrudQueryPredicate[] {
        const filters: CrudQueryPredicate[] = [];
        return filters;
    }

    getPayload() {
        return createCrudQueryPayload<TargetModel>({ field: 'createdAt', index: 1, order: 'desc' }, this.getFilters());
    }

    open(item: TargetModel) {
        if (this.dialog && typeof (this.dialog as any).open === 'function') {
            (this.dialog as any).open(item.id!);
        }
    }

    createItemClick() {
        if (this.dialog && typeof (this.dialog as any).open === 'function') {
            (this.dialog as any).open(Guid.EmptyGuid());
        }
    }

    scopeName(item: any): string {
        if (item?.workplace?.name) {
            return `${item.workplace.name} (${this.$t('targets.scope.workplace')})` as any;
        }
        if (item?.location?.name) {
            return `${item.location.name} (${this.$t('targets.scope.location')})` as any;
        }
        return `${this.$t('targets.scope.global')}` as any;
    }

    formatMonth(dateStr?: string | null): string {
        if (!dateStr) return '';
        return moment(dateStr).format('MM/YYYY');
    }
}
 